/**
 * PersonalSpace Icon — "Persönlich" Life Space
 *
 * Rocket icon from Figma design.
 * Compatible with Lucide icon API (size + color props).
 *
 * Two states: monochrome (default, `currentColor`/`color`-themed) and the fixed
 * full-color Figma variant via `colored` (e.g. the list-mode project switcher).
 *
 * @example
 * <PersonalSpaceIcon size={16} />
 * <PersonalSpaceIcon size={16} colored />
 */
export const PersonalSpaceIcon = ({ size = 16, color, colored = false }: { size?: number; color?: string; colored?: boolean }) => {
  if (colored) {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.5005 6L13.4815 7.325C14.4515 4.212 15.0005 1 15.0005 1C15.0005 1 6.0245 2.524 3.5435 5.006C1.4855 7.064 1.4855 10.4 3.5435 12.457C5.6015 14.514 8.9365 14.514 10.9945 12.457C11.4765 11.975 11.9215 11.244 12.3275 10.385L10.5005 6Z"
          fill="#DDD6FE" stroke="#6D28D9" strokeWidth="1.33" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"
        />
        <path d="M1 15L7.5 8.5" stroke="#6D28D9" strokeWidth="1.33" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 6L13.48 7.33C14.45 4.21 15 1 15 1C15 1 6.02 2.52 3.54 5.01C1.49 7.06 1.49 10.4 3.54 12.46C5.6 14.51 8.94 14.51 10.99 12.46C11.48 11.97 11.92 11.24 12.33 10.38L10.5 6Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 15L7.5 8.5"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
